/* https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values */
export enum KeyCodes {
  BACKSPACE = 'Backspace',
  COMMA = ',',
  SPACE = ' ',
  DELETE = 'Delete',
  ENTER = 'Enter',
}
